export default "__VITE_ASSET__BgUVDnzt__"